
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EpbCheckbox',
  props: {
    value: Boolean,
    color: {
      type: String,
      default: 'primary',
    },
    checkboxPosition: {
      // left, right
      type: String,
      default: 'left',
    },
    alwaysFilled: Boolean,
    disabled: Boolean,
  },
})
